import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import {getUserData} from '@/auth/utils'
import reservation from '@/router/routes/reservation'
import meals from '@/router/routes/meals'
import food from '@/router/routes/food'
import reports from '@/router/routes/reports'
import agenda from '@/router/routes/agenda'
import dashboard from './routes/dashboard'
import pages from './routes/pages'
import userManagment from './routes/user-managment'
import tickets from './routes/tickets'
import projects from './routes/projects'
import todo from './routes/todo'
import requestProcess from './routes/process'
import request from './routes/request'
import vote from './routes/vote'
import hr from "./routes/hr";
import meeting from "./routes/meeting";
import settings from "./routes/settings";

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {
            x: 0,
            y: 0,
        }
    },
    routes: [
        {
            path: '/',
            redirect: {name: 'dashboard'},
        },
        ...dashboard,
        ...pages,
        ...userManagment,
        ...tickets,
        ...projects,
        ...todo,
        ...requestProcess,
        ...request,
        ...reservation,
        ...meals,
        ...food,
        ...vote,
        ...reports,
        ...agenda,
        ...hr,
        ...meeting,
        ...settings,
        {
            path: '*',
            redirect: 'error-404',
        },
    ],
})

router.beforeEach(async (to, _, next) => {
    const userData = await getUserData()
    //
    if (userData && userData.needChangePassword && to.name !== 'Force_Change_Pass') {
        return next({name: 'Force_Change_Pass'})
    }
    if (to.meta.authRequired && !userData) {
        return next({name: 'auth-login'})
    }
    if (to.name === 'auth-login' && userData) {
        return next({path: '/'})
    }

    if (userData && !userData.roles.includes('Administrator')) {
        if (to.meta.authRequired && to.meta.permission) {
            if (!userData.permissions || !userData.permissions.includes(to.meta.permission)) return next({name: 'misc-not-authorized'})
        }
    }

    return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

export default router
